import appconfig from '@/utils/appConfig';
import clsx from 'clsx';
import { FieldProps } from 'formik';

interface RadioButtonProps {
    field: FieldProps['field'];
    id: string;
    label: string;
    className?: string;
    onValueChange?: (_value: string) => void;
}

const RadioButton = ({
    field: { name, value, onChange, onBlur },
    id,
    label,
    className = '',
    onValueChange,
    ...props
}: RadioButtonProps) => {
    const radioClasses = clsx(
        'h-4',
        'w-4',
        'cursor-pointer',
        'rounded-full',
        'border-2',
        `${appconfig.colors.primaryBg}`,
        'text-gray-800',
        'focus:ring-gray-200',
        'mr-2',
        'radio-button',
        className
    );

    const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e);
        if (onValueChange) {
            onValueChange(e.target.value);
        }
    };

    return (
        <div className="flex justify-center items-center">
            <label
                htmlFor={`${name}-${id}`}
                className="cursor-pointer mr-1 text-sm font-medium"
            >
                {label}
            </label>
            <input
                {...props}
                name={name}
                id={`${name}-${id}`}
                type="radio"
                value={id}
                checked={id === value}
                onChange={handleRadioChange}
                onBlur={onBlur}
                className={radioClasses}
            />
        </div>
    );
};

export default RadioButton;
